export const RETRIEVE_VILLES = "RETRIEVE_VILLES";
export const RETRIEVE_COMMUNES = "RETRIEVE_COMMUNES";
export const RETRIEVE_CLINIQUES = "RETRIEVE_CLINIQUES";